import { combineReducers } from 'redux'
import ChatManagementMessageListSlice from '../../slices/experiences/ChatManagementMessageListSlice'
import ChatManagementChatGroupListSlice from '../../slices/experiences/ChatManagementChatGroupListSlice'
import chatManagementActiveContextReducer from './ChatManagement/activeContext'

const ChatManagementExperienceStore = combineReducers({
  messageList: ChatManagementMessageListSlice.reducer,
  chatGroupList: ChatManagementChatGroupListSlice.reducer,
  activeContext: chatManagementActiveContextReducer
})

export default ChatManagementExperienceStore
